import React from "react";
import Fonts from "../../Config/Fonts";
import Colors from "../../theme/Colors";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div style={paginationContainer}>
      <span
        onClick={handlePrevPage}
        style={currentPage === 1 ? disabledButtonStyle : buttonStyle}
      >
        Prev
      </span>

      <span style={pageInfoStyle}>
        Page {currentPage} of {totalPages}
      </span>

      <span
        onClick={handleNextPage}
        style={currentPage === totalPages ? disabledButtonStyle : buttonStyle}
      >
        Next
      </span>
    </div>
  );
};

// Styling for the Pagination component
const paginationContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  bottom: 0,
  left: 0,
  backgroundColor: "white",
  padding: "10px 10px",
  zIndex: 10,
  borderTop: "1px solid #ddd",
};

const buttonStyle = {
  fontSize: 14,
  fontWeight: 700,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  padding: "10px 15px",
  cursor: "pointer",
};

const disabledButtonStyle = {
  ...buttonStyle,
  color: Colors.breadCrumbsColor,
  cursor: "not-allowed",
};

const pageInfoStyle = {
  fontSize: 14,
  fontWeight: 400,
  fontFamily: Fonts.Poppins,
  color: Colors.lightBlack,
};

export default Pagination;
